import { Modal } from "react-bootstrap";
import { BiGift } from "react-icons/bi";
import '../style/style.css';
import "bootstrap/dist/css/bootstrap.min.css";

function GiftModal({ show, winnerData, group, handleClose, onConfirm, }) {  
  return (
    <Modal 
     show={show} 
     onHide={handleClose} 
     size="lg"
    //  centered            
    >     
        <div className="col-12">
            <Modal.Header 
                closeButton                
                className="justify-content-center" 
            >          
                <Modal.Title className="w-100">
                    <div className="text-center">
                        <button 
                            className="btn rounded-pill fw-bold spin-heading"                            
                        >      
                            Spin & Win
                        </button>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div 
                className="container p-3 d-flex justify-content-center align-items-center  w-md-75"                                   
            >
                <div className="text-center gift-modal-background"  style={{borderRadius:"30px", width:'500px'}} >
                    <img 
                        src="/img/eastwestlogo.png" 
                        alt="east-west-logo" 
                        height="100px"
                        width="200px"
                        className="mt-2"                        
                    />
                    <p className="fw-bold p-0 m-0 mt-2">
                        Congratulations
                    </p> 
                    <span className="mt-2 d-block">
                        <BiGift 
                            fontSize="80px"
                        />
                    </span>                                                
                    {/* <p className="fw-medium mt-2">
                        You won {winnerData} on {group}
                    </p> */}
                     <p className="fw-medium mt-2 text-center">
                        You won {winnerData}
                    </p>
                </div>
            </div>              
            </Modal.Body>
            {/* <Modal.Footer className="d-flex flex-row justify-content-center">                                        
            </Modal.Footer>                  */}
        </div>             
       
    </Modal>
  );
}

export default GiftModal;


// import { Modal } from "react-bootstrap";
// import { BiGift } from "react-icons/bi";
// import '../style/style.css';
// import "bootstrap/dist/css/bootstrap.min.css";

// function GiftModal({ show, winnerData, group, handleClose, onConfirm }) {
//   return (
//     <Modal show={show} onHide={handleClose} size="lg" > 
//       <div className="col-12">
//         <Modal.Header closeButton className="justify-content-center">
//           <Modal.Title>
//             <div className="text-center">
//               <button className="btn rounded-pill fw-bold spin-heading">
//                 Spin & Win
//               </button>
//             </div>
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div 
//             className="container p-3 d-flex flex-column justify-content-center align-items-center gift-modal-background"
//             style={{ borderRadius: "30px", maxWidth: "500px" }}
//           >
//             <div className="text-center">
//               <img 
//                 src="/img/eastwestlogo.png" 
//                 alt="east-west-logo" 
//                 className="mt-2 img-fluid"
//                 style={{ maxHeight: "100px", maxWidth: "200px" }}
//               />
//               <p className="fw-bold p-0 m-0 mt-2">Congratulations</p> 
//               <span className="mt-2 d-block">
//                 <BiGift fontSize="80px" />
//               </span>                                                 
//               <p className="fw-medium mt-2 text-center">
//                 You won {winnerData} on {group}
//               </p>
//             </div>
//           </div>              
//         </Modal.Body>
//       </div>             
//     </Modal>
//   );
// }

// export default GiftModal;


// import { Modal } from "react-bootstrap";
// import { BiGift } from "react-icons/bi";
// import '../style/style.css';
// import "bootstrap/dist/css/bootstrap.min.css";

// function GiftModal({ show, winnerData, group, handleClose, onConfirm }) {
//   return (
//     <Modal show={show} onHide={handleClose} size="md" centered>
//       <Modal.Header closeButton className="justify-content-center">
//         <Modal.Title className="w-100 text-center">
//           <button className="btn rounded-pill fw-bold spin-heading">
//             Spin & Win
//           </button>
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body className="d-flex justify-content-center">
//         <div 
//           className="p-3 d-flex flex-column justify-content-center align-items-center gift-modal-background w-100"
//           style={{ borderRadius: "20px", maxWidth: "400px", width: "90%" }}
//         >
//           <div className="text-center">
//             <img 
//               src="/img/eastwestlogo.png" 
//               alt="east-west-logo" 
//               className="mt-2 img-fluid"
//               style={{ maxHeight: "80px", maxWidth: "160px" }}
//             />
//             <p className="fw-bold p-0 m-0 mt-2">Congratulations</p> 
//             <span className="mt-2 d-block">
//               <BiGift fontSize="60px" />
//             </span>                                                  
//             <p className="fw-medium mt-2 text-center">
//               You won {winnerData} on {group}
//             </p>
//           </div>
//         </div>              
//       </Modal.Body>
//     </Modal>
//   );
// }

// export default GiftModal;
